import { Form, Formik } from 'formik';

import { type Contact } from '@/types/trpc/contact';

import useContactForm, { type ContactFormValues } from './useContactForm';

import AddEditContactFormBody from '@/containers/Contacts/AddEditContact/AddEditContactFormBody';

type Props = {
  contact?: Contact;
  disabled?: boolean;
  isSubmitting?: boolean;
  minified?: boolean;
  onCancel: () => void;
  onSubmit: (values: ContactFormValues) => void;
};

const AddEditContactForm: React.FC<Props> = ({
  contact,
  disabled = false,
  isSubmitting = false,
  minified = false,
  onCancel,
  onSubmit,
}) => {
  const { initialValues, validationSchema } = useContactForm({ initialContact: contact });

  return (
    <Formik
      validateOnMount
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(formik) => (
        <Form>
          <AddEditContactFormBody
            disabled={disabled}
            isSubmitting={formik.isSubmitting || isSubmitting}
            minified={minified}
            onCancel={onCancel}
          />
        </Form>
      )}
    </Formik>
  );
};

export default AddEditContactForm;
